import {useContext, useEffect} from 'react';

import {DateRangePickerContext} from "contexts/DateRangePickerContext";
import {OrderListContext} from "../context/OrderListContext";
import {isPeriodNeutralized} from "../utils/isPeriodNeutralized";

function QueryParamsSync() {
    const {startDate, endDate, dateChangedTrigger} = useContext(DateRangePickerContext);
    const {setQueryParams} = useContext(OrderListContext);

    useEffect(() => {
        setQueryParams((previousQueryParams) => {
            const params = new URLSearchParams(previousQueryParams);
            const previousAfter = params.get('createdAt[after]');
            const previousBefore = params.get('createdAt[before]');
            let changed;

            // a search (or a receipt value filter) spans every date (see getInitialDates/withDefaultDatesIfNeeded) - on
            // mount after navigating back from an order, DateRangePickerContext still defaults
            // startDate/endDate to the last 7 days even though no period was restored, so this
            // branch must not reintroduce one here and silently narrow the search's results
            if (isPeriodNeutralized(params)) {
                return previousQueryParams;
            }

            if (startDate && endDate) {
                const after = startDate.clone().startOf('day').format('YYYY-M-D HH:mm:ss');
                const before = endDate.clone().endOf('day').format('YYYY-M-D HH:mm:ss');

                changed = after !== previousAfter || before !== previousBefore;

                params.set('createdAt[after]', after);
                params.set('createdAt[before]', before);
            } else if (!startDate && !endDate) {
                changed = previousAfter !== null || previousBefore !== null;

                params.delete('createdAt[after]');
                params.delete('createdAt[before]');
            } else {
                return previousQueryParams;
            }

            // only bump back to page 1 when the period actually changed - on
            // mount, startDate/endDate may already match a period restored
            // from the URL (e.g. navigating back from an order), and the
            // restored page shouldn't be lost just because this effect runs
            if (changed) {
                params.set('page', '1');
            }

            return params.toString();
        });
    }, [dateChangedTrigger, setQueryParams]);

    return null;
}

export default QueryParamsSync;
